import {
  getAnimation,
  setAnimation,
  setDefaultAnimation
} from "../chunks/chunk.K7JGTRV7.js";
import "../chunks/chunk.KAW7D32O.js";
export {
  getAnimation,
  setAnimation,
  setDefaultAnimation
};
